import { useState, useEffect } from "react"
import {
  Button,
  Box,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material"
import theme from "../../../theme"
import { useNavigate } from "react-router-dom"
import { useTranslation } from 'react-i18next';

const HeroSection = () => {
  const navigate = useNavigate()
  const { t } = useTranslation();
  const brandName = t('brand.name');
  const muiTheme = useTheme()
  const isMobile = useMediaQuery(muiTheme.breakpoints.down("md"))
  const isSmallMobile = useMediaQuery(muiTheme.breakpoints.down("sm"))

  const handleFindSalon = () => {
    window.sessionStorage.removeItem("glow.searchSalonState")
    navigate("/search-salon")
  }

  // Responsive styles
  const containerStyles = {
    maxWidth: "1200px",
    margin: "0 auto",
    padding: isSmallMobile ? "32px 56px 50px" : isMobile ? "40px 60px 60px" : "80px 40px 100px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    minHeight: isMobile ? "80vh" : "90vh",
    justifyContent: "center",
    width: "100%",
    boxSizing: "border-box",
    position: "relative",
  }

  const titleStyles = {
    fontSize: isMobile ? (isSmallMobile ? "2rem" : "2.5rem") : "3.5rem",
    fontWeight: 700,
    color: theme.colors.primary[800],
    marginBottom: isMobile ? "20px" : "32px",
    lineHeight: 1.2,
    letterSpacing: "-0.02em",
    textShadow: "0 2px 4px rgba(0,0,0,0.1)",
    maxWidth: isMobile ? "100%" : "900px",
  }

  const subtitleStyles = {
    fontSize: isMobile ? (isSmallMobile ? "1rem" : "1.1rem") : "1.25rem",
    color: theme.colors.text.secondary,
    marginBottom: isMobile ? "40px" : "64px",
    lineHeight: 1.6,
    maxWidth: isMobile ? "100%" : "700px",
    fontWeight: 400,
    opacity: 0.9,
  }

  const buttonStyles = {
    backgroundColor: theme.colors.primary[600],
    color: "white",
    padding: isMobile ? "16px 32px" : "20px 40px",
    borderRadius: "50px",
    fontSize: isMobile ? "1.1rem" : "1.25rem",
    fontWeight: 600,
    border: "none",
    cursor: "pointer",
    boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
    transition: "all 0.3s ease",
    "&:hover": {
      backgroundColor: theme.colors.primary[700],
      transform: "translateY(-2px)",
      boxShadow: "0 6px 24px rgba(0,0,0,0.2)",
    },
  }

  return (
    <div id="heroSection" style={containerStyles}>
      {/* Title */}
      <h1 style={titleStyles}>{t('landing_hero.title', { appName: brandName })}</h1>

      {/* Subtitle */}
      <p style={subtitleStyles}>
        {t('landing_hero.subtitle')}
      </p>

      {/* Find Salon Button */}
      <Button
        onClick={handleFindSalon}
        sx={{
          backgroundColor: theme.colors.primary[600],
          color: "white",
          padding: isMobile ? "16px 32px" : "20px 40px",
          borderRadius: "50px",
          fontSize: isMobile ? "1.1rem" : "1.25rem",
          fontWeight: 600,
          boxShadow: "0 4px 16px rgba(0,0,0,0.15)",
          "&:hover": {
            backgroundColor: theme.colors.primary[700],
            transform: "translateY(-2px)",
            boxShadow: "0 6px 24px rgba(0,0,0,0.2)",
          },
        }}
      >
        {t('landing_hero.find_salon')}
      </Button>
    </div>
  )
}

export default HeroSection
